import InputPresenter from "../presenter/input.js";

import SliderWrapperView from "../view/slider/wrapper.js";
import SliderView from "../view/slider/slider.js";

import SliderModel from "../model/slider.js";
import SliderWrapperModel from "../model/slider-wrapper.js";

import Animation from "../../../animation/animation.js";

import {
  render
} from "../../../render/render.js";

import {
  setTemporaryTransition
} from "../../../../utils/set-temporary-transition/set-temporary-transition.js";

import {
  ActionType,
  defaultSliderModelData,
  defaultSliderWrapperModelData,
  SliderTrigger,
  PROPERTIES_SEPARATOR
} from "../../const.js";
export default class Slider {
  constructor(
      element,
      changeFilter,
      formElement,
      resetPresenter,
      browserNavigation
  ) {
    this._element = element;
    this._changeFilter = changeFilter;
    this._formElement = formElement;
    this._resetPresenter = resetPresenter;
    this._browserNavigation = browserNavigation;

    this._animation = new Animation();

    this._sliderWrapperView = null;
    this._sliderView = null;

    this._sliderModel = null;
    this._sliderWrapperModel = null;

    this._inputsPresenters = {};
    this._isHoldedOnce = false;

    this._windowMouseDownHandler = this._windowMouseDownHandler.bind(this);
    this._windowMouseMoveHandler = this._windowMouseMoveHandler.bind(this);
    this._windowMouseUpHandler = this._windowMouseUpHandler.bind(this);
    this._windowTouchStartHandler = this._windowTouchStartHandler.bind(this);
    this._windowTouchMoveHandler = this._windowTouchMoveHandler.bind(this);
    this._windowTouchEndHandler = this._windowTouchEndHandler.bind(this);
    this._handleSliderWrapperButtonClick = this._handleSliderWrapperButtonClick.bind(this);
    this._handleSliderWrapperDataChange = this._handleSliderWrapperDataChange.bind(this);
    this._handleModelChange = this._handleModelChange.bind(this);
    this._handleActiveRangeClick = this._handleActiveRangeClick.bind(this);
    this._handleBaseRangeClick = this._handleBaseRangeClick.bind(this);
    this._afterResetClick = this._afterResetClick.bind(this);
    this._handleBrowserNavigation = this._handleBrowserNavigation.bind(this);
  }

  init() {
    this._sliderWrapperModel = new SliderWrapperModel(Object.assign(
        {},
        defaultSliderWrapperModelData
    ));
    this._sliderWrapperModel.addObserver(this._handleSliderWrapperDataChange);

    this._sliderWrapperView = new SliderWrapperView(this._element);
    this._sliderWrapperView.setButtonClickHandler(this._handleSliderWrapperButtonClick);

    this._inputsPresenters.from = new InputPresenter(
        this._sliderWrapperView.getInputFromElement(),
        SliderTrigger.FROM,
        this
    );
    this._inputsPresenters.to = new InputPresenter(
        this._sliderWrapperView.getInputToElement(),
        SliderTrigger.TO,
        this
    );

    this._inputsPresenters.from.init(this._inputsPresenters.to);
    this._inputsPresenters.to.init(this._inputsPresenters.from);

    this._initModel();

    this._sliderView = new SliderView();
    render(this._sliderWrapperView.getFieldsetContent(), this._sliderView.getElement());

    this._handleModelChange = this._handleModelChange.bind(this);

    window.addEventListener(`mousedown`, this._windowMouseDownHandler);
    window.addEventListener(`touchstart`, this._windowTouchStartHandler, {
      passive: false
    });

    this._sliderView.setActiveRangeClickHandler(this._handleActiveRangeClick);
    this._sliderView.setBaseRangeClickHandler(this._handleBaseRangeClick);

    this._updateSliderAfterInit();

    this._resetPresenter.addObserver(this._afterResetClick);
    this._resetPresenter.addItem(`sliders`, this);

    this._browserNavigation.addObserver(this._handleBrowserNavigation);
  }

  getModelData() {
    return this._sliderModel.getData();
  }

  updateEnabledValues(enabledData) {
    const name = this._inputsPresenters.from.getName();

    if (!enabledData[name]) {
      return;
    }

    const enabledItemData = enabledData[name][`data`];

    const selectedProperties = this.getSelectedProperties();
    const isSelected = (selectedProperties.indexOf(name) !== -1);

    if (isSelected) {
      return;
    }

    if (!enabledItemData.min || !enabledItemData.max) {
      return;
    }

    const newFromValue = +enabledItemData.min;
    const newToValue = +enabledItemData.max;

    this._updateEnabled(newFromValue, newToValue);
  }

  getName() {
    return this._sliderWrapperView.getName();
  }

  reset() {
    const selectedProperties = this.getSelectedProperties();
    const isSelected = (selectedProperties.indexOf(name) !== -1);

    if (isSelected) {
      return;
    }

    const modelData = this._sliderModel.getData();
    this._updateEnabled(modelData.min, modelData.max);
  }

  forceReset() {
    const modelData = this._sliderModel.getData();

    this._sliderModel.changeData(Object.assign(
        modelData,
        {
          fromValue: modelData.min,
          toValue: modelData.max,
          isReset: true
        }
    ));

    this._inputsPresenters.from.setValue(null);
    this._inputsPresenters.to.setValue(null);
  }

  getSliderElement() {
    return this._sliderView.getElement();
  }

  getInputsElements() {
    return [
      this._inputsPresenters.from.getElement(),
      this._inputsPresenters.to.getElement()
    ];
  }

  getResetPresenter() {
    return this._resetPresenter;
  }

  getIsHoldedOnce() {
    return this._isHoldedOnce;
  }

  getSliderData() {
    return this._sliderModel.getData();
  }

  changeSliderFromInput(activeTrigger, activeTriggerNewValue) {
    const activeElement = this._getActiveElement(activeTrigger);
    const modelData = this._sliderModel.getData();

    switch (activeTrigger) {
      case SliderTrigger.FROM:
        this._sliderModel.changeData(
            Object.assign(
                {},
                modelData,
                {
                  fromValue: activeTriggerNewValue,
                  isReset: false
                }
            ),
            ActionType.CHANGE_SLIDER_INPUT,
            {
              activeTrigger
            }
        );
        break;
      case SliderTrigger.TO:
        this._sliderModel.changeData(
            Object.assign(
                {},
                modelData,
                {
                  toValue: activeTriggerNewValue,
                  isReset: false
                }
            ),
            ActionType.CHANGE_SLIDER_INPUT,
            {
              activeTrigger
            }
        );
        break;
    }

    const min = modelData.min;
    const range = modelData.range;

    let activeElementShift = (activeTriggerNewValue - min) * 100 / range;

    if (activeElementShift < 0) {
      activeElementShift = 0;
    } else if (activeElementShift > 100) {
      activeElementShift = 100;
    }

    activeElement.style.left = `${activeElementShift}%`;

    const activeRangeElement = this._sliderView.getActiveRangeElement();
    const sliderWidth = this._sliderView.getElement().offsetWidth;
    const activeElementOffset = activeElementShift * sliderWidth / 100;

    const toTriggerOffset = this._sliderView.getButtonToElementOffset();
    const fromTriggerOffset = this._sliderView.getButtonFromElementOffset();

    switch (activeTrigger) {
      case SliderTrigger.FROM:
        activeRangeElement.style.left = `${activeElementOffset / sliderWidth * 100}%`;
        break;
    }

    activeRangeElement.style.width = `${(toTriggerOffset - fromTriggerOffset) / sliderWidth * 100}%`;
  }

  getSelectedProperties() {
    return Array
      .from(new FormData(this._formElement))
      .filter((item) => {
        return item[1] !== ``;
      })
      .map((item) => {
        return item[0];
      })
      .filter((value, index, array) => {
        return array.indexOf(value) === index;
      });
  }

  _afterResetClick() {
    const modelData = this._sliderModel.getData();

    this._sliderModel.changeData(
        Object.assign(
            {},
            modelData,
            {
              fromValue: modelData.min,
              toValue: modelData.max,
              isReset: true
            }
        ),
        ActionType.FORM_RESET
    );
  }

  _initModel() {
    const min = this._inputsPresenters.from.getMin();
    const max = this._inputsPresenters.to.getMax();
    const range = max - min;

    const fromValue = this._inputsPresenters.from.getValue() || this._inputsPresenters.from.getDefault();
    const toValue = this._inputsPresenters.to.getValue() || this._inputsPresenters.to.getDefault();
    const dataset = this._sliderWrapperView.getElementDataset();

    this._sliderModel = new SliderModel(
        Object.assign(
            {},
            defaultSliderModelData,
            {
              range,
              min,
              max,
              fromValue,
              toValue,
              rounding: (dataset.rounding) ?
                +dataset.rounding :
                null
            }
        )
    );
    this._sliderModel.addObserver(this._handleModelChange);
  }

  _getActiveTrigger(target) {
    if (target === this._sliderView.getButtonFromElement()) {
      return SliderTrigger.FROM;
    }

    if (target === this._sliderView.getButtonToElement()) {
      return SliderTrigger.TO;
    }

    return null;
  }

  _getActiveElement(trigger) {
    if (trigger === SliderTrigger.FROM) {
      return this._sliderView.getButtonFromElement();
    }

    if (trigger === SliderTrigger.TO) {
      return this._sliderView.getButtonToElement();
    }

    return null;
  }

  _changeSlider(cursorX, activeTrigger, isUpdate = false) {
    const modelData = this._sliderModel.getData();
    const activeElement = this._getActiveElement(activeTrigger);
    const activeRangeElement = this._sliderView.getActiveRangeElement();
    const sliderOffset = this._sliderView.getElementOffset();
    const sliderWidth = this._sliderView.getElement().offsetWidth;

    let toTriggerOffset = this._sliderView.getButtonToElementOffset();
    let fromTriggerOffset = this._sliderView.getButtonFromElementOffset();

    let activeElementOffset;

    switch (activeTrigger) {
      case SliderTrigger.FROM:
        if (cursorX >= sliderOffset && cursorX <= toTriggerOffset) {
          activeElementOffset = cursorX - sliderOffset;
        }

        if (cursorX > toTriggerOffset) {
          activeElementOffset = toTriggerOffset - sliderOffset;
        }

        if (cursorX < sliderOffset) {
          activeElementOffset = 0;
        }

        activeRangeElement.style.left = `${activeElementOffset / sliderWidth * 100}%`;
        activeRangeElement.style.width = `${(toTriggerOffset - sliderOffset - activeElementOffset) / sliderWidth * 100}%`;
        break;
      case SliderTrigger.TO:
        if (cursorX >= fromTriggerOffset && cursorX <= (sliderOffset + sliderWidth)) {
          activeElementOffset = cursorX - sliderOffset;
        }

        if (cursorX > (sliderOffset + sliderWidth)) {
          activeElementOffset = sliderWidth;
        }

        if (cursorX < fromTriggerOffset) {
          activeElementOffset = fromTriggerOffset - sliderOffset;
        }

        activeRangeElement.style.width = `${(sliderOffset + activeElementOffset - fromTriggerOffset) / sliderWidth * 100}%`;
        break;
    }

    const activeElementShift = activeElementOffset / sliderWidth * 100;
    activeElement.style.left = `${activeElementShift}%`;

    const range = modelData.range;
    const min = modelData.min;
    const max = modelData.max;
    const fromValue = modelData.fromValue;
    const toValue = modelData.toValue;
    const rounding = modelData.rounding;

    let activeTriggerNewValue = parseInt((min + activeElementShift * range / 100), 10);

    if (rounding) {
      activeTriggerNewValue = Math.round(activeTriggerNewValue / rounding, 10) * rounding;

      if (activeTriggerNewValue < min) {
        activeTriggerNewValue = min;
      } else if (activeTriggerNewValue > max) {
        activeTriggerNewValue = max;
      }
    }


    switch (activeTrigger) {
      case SliderTrigger.FROM:
        if (activeTriggerNewValue > toValue) {
          activeTriggerNewValue = toValue;
        }

        this._sliderModel.changeData(
            Object.assign(
                {},
                modelData,
                {
                  fromValue: activeTriggerNewValue,
                  isReset: false
                }
            ),
            ActionType.HANDLER_MOVE,
            {
              activeTrigger,
              isUpdate
            }
        );
        break;
      case SliderTrigger.TO:
        if (activeTriggerNewValue < fromValue) {
          activeTriggerNewValue = fromValue;
        }

        this._sliderModel.changeData(
            Object.assign(
                {},
                modelData,
                {
                  toValue: activeTriggerNewValue,
                  isReset: false
                }
            ),
            ActionType.HANDLER_MOVE,
            {
              activeTrigger,
              isUpdate
            }
        );
        break;
    }
  }

  _moveSlider(fromValue, toValue) {
    const modelData = this._sliderModel.getData();
    const sliderWidth = this._sliderView.getBaseRangeElement().offsetWidth;
    const numPerPixel = modelData.range / sliderWidth;

    const fromTrigger = this._sliderView.getButtonFromElement();
    setTemporaryTransition(fromTrigger);
    const newFromTriggerShift = (fromValue - modelData.min) / numPerPixel * 100 / sliderWidth;

    fromTrigger.style.left = `${newFromTriggerShift}%`;

    const toTrigger = this._sliderView.getButtonToElement();
    setTemporaryTransition(toTrigger);
    const newToTriggerShift = (toValue - modelData.min) / numPerPixel * 100 / sliderWidth;

    toTrigger.style.left = `${newToTriggerShift}%`;

    const activeRangeElement = this._sliderView.getActiveRangeElement();
    setTemporaryTransition(activeRangeElement);
    activeRangeElement.style.left = `${newFromTriggerShift}%`;
    activeRangeElement.style.width = `${newToTriggerShift - newFromTriggerShift}%`;
  }

  _updateEnabled(fromValue, toValue) {
    this._moveSlider(fromValue, toValue);

    if (!this._inputsPresenters.from.getValue()) {
      this._inputsPresenters.from.setPlaceholder(fromValue);
    }

    if (!this._inputsPresenters.to.getValue()) {
      this._inputsPresenters.to.setPlaceholder(toValue);
    }
  }

  _updateSliderAfterInit() {
    const modelData = this._sliderModel.getData();

    this._moveSlider(modelData.fromValue, modelData.toValue);
  }

  _processFieldsetActivate() {
    this._animation.fadeIn(
        this._sliderWrapperView.getFieldsetContent(),
        null,
        () => {
          this._sliderWrapperView.resetFieldsetContent();
        }
    );

    this._sliderWrapperView.activate();
  }

  _processFieldsetDeactivate() {
    this._animation.fadeOut(
        this._sliderWrapperView.getFieldsetContent(),
        null,
        () => {
          this._sliderWrapperView.hideFieldsetContent();
        }
    );

    this._sliderWrapperView.deactivate();
  }

  _windowMouseDownHandler(evt) {
    const activeTrigger = this._getActiveTrigger(evt.target);

    if (!activeTrigger) {
      return;
    }

    this._sliderModel.changeData(
        Object.assign(
            {},
            this._sliderModel.getData(),
            {
              isTriggered: true,
              activeTrigger
            }
        ),
        ActionType.HANDLER_HOLD,
        {
          activeTrigger
        }
    );

    window.addEventListener(`mouseup`, this._windowMouseUpHandler);
    window.addEventListener(`mousemove`, this._windowMouseMoveHandler);
  }

  _windowTouchStartHandler(evt) {
    if (evt.touches.length !== 1) {
      return;
    }

    const activeTrigger = this._getActiveTrigger(evt.target);

    if (!activeTrigger) {
      return;
    }

    evt.preventDefault();
    evt.stopImmediatePropagation();

    this._sliderModel.changeData(
        Object.assign(
            {},
            this._sliderModel.getData(),
            {
              isTriggered: true,
              activeTrigger
            }
        ),
        ActionType.HANDLER_HOLD,
        {
          activeTrigger
        }
    );

    window.addEventListener(`touchmove`, this._windowTouchMoveHandler, {
      passive: false
    });
    window.addEventListener(`touchend`, this._windowTouchEndHandler);
  }

  _windowMouseUpHandler() {
    window.removeEventListener(`mouseup`, this._windowMouseUpHandler);
    window.removeEventListener(`mousemove`, this._windowMouseMoveHandler);

    const activeTrigger = this._sliderModel.getData().activeTrigger;

    if (!activeTrigger) {
      return;
    }

    this._sliderModel.changeData(
        Object.assign(
            {},
            this._sliderModel.getData(),
            {
              isTriggered: false,
              activeTrigger: null
            }
        ),
        ActionType.HANDLER_RELEASE,
        {
          activeTrigger
        }
    );
  }

  _windowTouchEndHandler() {
    window.removeEventListener(`touchmove`, this._windowTouchMoveHandler);
    window.removeEventListener(`touchend`, this._windowTouchEndHandler);

    const activeTrigger = this._sliderModel.getData().activeTrigger;

    if (!activeTrigger) {
      return;
    }

    this._sliderModel.changeData(
        Object.assign(
            {},
            this._sliderModel.getData(),
            {
              isTriggered: false,
              activeTrigger: null
            }
        ),
        ActionType.HANDLER_RELEASE,
        {
          activeTrigger
        }
    );
  }

  _windowMouseMoveHandler(evt) {
    const modelData = this._sliderModel.getData();
    const activeTrigger = modelData.activeTrigger;

    this._changeSlider(evt.pageX, activeTrigger);
  }

  _windowTouchMoveHandler(evt) {
    evt.preventDefault();
    evt.stopPropagation();

    if (evt.touches.length !== 1) {
      return;
    }

    const modelData = this._sliderModel.getData();
    const activeTrigger = modelData.activeTrigger;

    this._changeSlider(evt.touches[0].pageX, activeTrigger);
  }

  _handleSliderWrapperButtonClick() {
    const modelData = this._sliderWrapperModel.getData();
    const action = (modelData.isActive) ?
      ActionType.DEACTIVATE_FIELDSET :
      ActionType.ACTIVATE_FIELDSET;

    this._sliderWrapperModel.changeData(Object.assign(
        {},
        modelData,
        {
          isActive: !modelData.isActive
        }
    ), action);
  }

  _handleActiveRangeClick(evt) {
    const cursorX = evt.clientX;

    const sliderOffset = this._sliderView.getActiveRangeElementOffset();
    const sliderWidth = this._sliderView.getActiveRangeElement().offsetWidth;

    const activeTrigger = ((cursorX - sliderOffset) <= sliderWidth / 2) ?
      SliderTrigger.FROM :
      SliderTrigger.TO;

    this._changeSlider(cursorX, activeTrigger, true);
  }

  _handleBaseRangeClick(evt) {
    const cursorX = evt.clientX;

    const activeTrigger = ((cursorX < this._sliderView.getButtonFromElementOffset())) ?
      SliderTrigger.FROM :
      SliderTrigger.TO;

    this._changeSlider(cursorX, activeTrigger, true);
  }

  _handleBrowserNavigation(params) {
    const name = this._inputsPresenters.from.getName();

    let values = params
      .filter((item) => {
        return item.name === name;
      })
      .map((item) => {
        item = item.values.split(PROPERTIES_SEPARATOR);

        return {
          min: Math.min(item[0], item[1]),
          max: Math.max(item[0], item[1])
        };
      });

    const modelData = this._sliderModel.getData();
    const options = {};

    if (values.length === 0) {
      values = {
        min: modelData.min,
        max: modelData.max
      };
      options.resetInputs = true;
    } else {
      values = values[0];
    }

    if (modelData.fromValue === values.min && modelData.toValue === values.max) {
      options.preventSliderMove = true;
    }

    this._sliderModel.changeData(
        Object.assign(
            {},
            modelData,
            {
              fromValue: values.min,
              toValue: values.max,
              isReset: (options.resetInputs) ? true : false
            }
        ), ActionType.BROWSER_NAVIGATE,
        options
    );
  }

  _handleSliderWrapperDataChange(action) {
    switch (action) {
      case ActionType.ACTIVATE_FIELDSET:
        this._processFieldsetActivate();
        break;
      case ActionType.DEACTIVATE_FIELDSET:
        this._processFieldsetDeactivate();
        break;
    }
  }

  _handleModelChange(action, options) {
    const modelData = this._sliderModel.getData();

    switch (action) {
      case ActionType.HANDLER_HOLD:
        this._isHoldedOnce = true;
        this._sliderView.setActiveButton(options.activeTrigger);

        if (!this._inputsPresenters.from.getValue()) {
          const fromDefault = this._inputsPresenters.from.getDefault();
          const fromPlaceholder = this._inputsPresenters.from.getPlaceholder();
          const fromValue = (fromPlaceholder > fromDefault) ? fromPlaceholder : fromDefault;

          this._inputsPresenters.from.setValue(fromValue);
        }

        if (!this._inputsPresenters.to.getValue()) {
          const toDefault = this._inputsPresenters.to.getDefault();
          const toPlaceholder = this._inputsPresenters.to.getPlaceholder();
          const toValue = (toPlaceholder < toDefault) ? toPlaceholder : toDefault;

          this._inputsPresenters.to.setValue(toValue);
        }
        break;
      case ActionType.HANDLER_RELEASE:
        this._changeFilter.updateProductsData();
        break;
      case ActionType.HANDLER_MOVE:
        const activeTrigger = options.activeTrigger;

        if (activeTrigger === SliderTrigger.FROM) {
          this._inputsPresenters.from.setValue(modelData.fromValue);
          this._inputsPresenters.from.setPlaceholder(modelData.fromValue);
        } else {
          this._inputsPresenters.to.setValue(modelData.toValue);
          this._inputsPresenters.to.setPlaceholder(modelData.toValue);
        }

        if (!this._inputsPresenters.from.getValue()) {
          this._inputsPresenters.from.setValue(this._inputsPresenters.from.getDefault());
        }

        if (!this._inputsPresenters.to.getValue()) {
          this._inputsPresenters.to.setValue(this._inputsPresenters.to.getDefault());
        }

        if (options.isUpdate === true) {
          this._changeFilter.updateProductsData();
        }
        break;
      case ActionType.CHANGE_SLIDER_INPUT:
        this._sliderView.setActiveButton(options.activeTrigger);
        break;
      case ActionType.FORM_RESET:
        this._moveSlider(modelData.fromValue, modelData.toValue);
        break;
      case ActionType.BROWSER_NAVIGATE:
        if (!options.preventSliderMove) {
          this._moveSlider(modelData.fromValue, modelData.toValue);
        }

        if (options.resetInputs) {
          this._inputsPresenters.from.setValue(null);
          this._inputsPresenters.to.setValue(null);
        } else {
          this._inputsPresenters.from.setValue(modelData.fromValue);
          this._inputsPresenters.to.setValue(modelData.toValue);
        }
        break;
    }
  }
}
